// S1 Singles Hub home (/collections/singles) - compact hero (search + two paths + deck list importer, S2), shop singles
// in stock (newest sets, quick add), build a competitive deck, staples with playsets, browse by set, kit, how / FAQ.
import { html, attr } from './singles-hub--core--html.js?v=c7c57de095';
import { api } from './singles-hub--api.js?v=c7c57de095';
import { claim } from './singles-hub--core--claim.js?v=c7c57de095';
import { cart } from './singles-hub--cart.js?v=c7c57de095';
import { route } from './singles-hub--config.js?v=c7c57de095';
import { config } from './singles-hub--config.js?v=c7c57de095';
import { money, pretty } from './singles-hub--format.js?v=c7c57de095';
import { cardArt, tierChip, bar, buildBar, crumbs, stepper, offlineNotice, OFFLINE, pageTitle, stockPill, sized, busy } from './singles-hub--components--ui.js?v=c7c57de095';
import { normAll, normCard, basketParam, availableListings, picksFor } from './singles-hub--stock.js?v=c7c57de095';
import { playsetLabel } from './singles-hub--components--host.js?v=c7c57de095';
import { comboState, comboView, comboActions } from './singles-hub--components--combo.js?v=c7c57de095';
import { pasteState, pasteBox, pasteActions, builderUrlForText } from './singles-hub--components--paste.js?v=c7c57de095';
import { toast, openCard } from './singles-hub--components--host.js?v=c7c57de095';
import { kitView, addKitItem, kitNote } from './singles-hub--components--kit.js?v=c7c57de095';
import { track } from './singles-hub--analytics.js?v=c7c57de095';

export function hubPage(el) {
  // the theme's server-rendered header (h1 + intro); taken before the first render, which may replace its slot
  const serverHead = (el.closest('.sh-hub') || document).querySelector('.sh-hero');
  return {
    state: Object.assign({ w: el.clientWidth || 1200, loading: true, offline: false, health: null, decks: null, sets: null, kit: null, popular: null, series: 'ME', archSort: 'build', qty: {}, inCart: {}, stAll: false, st4: false, kitAll: false, feat: {}, featSet: null, pShow: false }, comboState('hero'), pasteState()),
    onMount: (c) => {
      load(c);
      // stock shown on the hub always excludes what is already in the basket: refetch when the basket changes
      let sig = basketParam() || '';
      c._unsub = cart.subscribe(() => { const n = basketParam() || ''; if (n !== sig) { sig = n; refresh(c); } });
    },
    onDestroy: (c) => c._unsub && c._unsub(),
    // In the theme the Liquid section renders the SEO h1 + intro ABOVE the app, which pushed the paste panel
    // (and every section after it) below the intro. Move that header into the hero's left column so the paste
    // panel sits beside it, and the breadcrumbs end up above the h1 (operator 2026-10-09). The node keeps its
    // server-rendered h1; data-morph-skip keeps re-renders from clearing it. JS off / VM down: it stays put.
    // The theme now renders it in that slot already (no jump on first paint); older section markup still works.
    afterRender: (c) => {
      const slot = c.root.querySelector('[data-mcc-hero-head]');
      const head = slot && serverHead;
      const n = inStockOf(c.state.health);
      const cnt = head && head.querySelector('[data-mcc-instock]');
      if (cnt && n) cnt.textContent = `${n.toLocaleString('en-GB')} in stock`;
      if (!head || head.parentNode === slot) return;
      head.classList.remove('page-width');
      head.classList.add('sh-hero--in-app');
      slot.appendChild(head);
    },
    view,
    actions: Object.assign({
      sortArch: (b, e, c) => { track('hub_sort_used', { area: 'hub_decks', sort: b.dataset.v }); c.setState({ archSort: b.dataset.v }); },
      heroCta: (b) => track('hub_hero_cta', { cta: b.dataset.cta }),
      pShow: (b, e, c) => { track('hub_hero_cta', { cta: 'paste_open' }); c.setState({ pShow: true }, () => { const t = c.root.querySelector('#mcc-hub-paste'); if (t) t.focus(); }); },
      featTab: (b, e, c) => { track('hub_filter_used', { area: 'hub_shelf', filter: 'set', value: b.dataset.v }); loadFeat(c, b.dataset.v); },
      featAll: (b) => track('hub_shelf_see_all', { set: b.dataset.v }),
      shelfAdd: (b, e, c) => busy(b, () => addShelf(b.dataset.v, b.dataset.n)),
      deckOpen: (b) => track('hub_deck_open', { deck: b.dataset.slug }),
      setOpen: (b) => track('hub_set_open', { set: b.dataset.v }),
      st4: (b, e, c) => { track('hub_filter_used', { area: 'hub_staples', filter: 'playset_available', value: String(!c.state.st4) }); c.setState({ st4: !c.state.st4 }); },
      kitAll: (b, e, c) => c.setState({ kitAll: !c.state.kitAll }),
      series: (b, e, c) => c.setState({ series: b.dataset.v, setsAll: false }),
      popular: (b) => location.assign(route('cardSearch', { q: b.dataset.q })),
      stAll: (b, e, c) => c.setState({ stAll: !c.state.stAll }),
      setsAll: (b, e, c) => c.setState({ setsAll: true }),
      openCard: (b) => openCard(b.dataset.id, { printingId: b.dataset.pid }),
      qMinus: (b, e, c) => c.setState({ qty: Object.assign({}, c.state.qty, { [b.dataset.k]: Math.max(1, (c.state.qty[b.dataset.k] || 1) - 1) }) }),
      qPlus: (b, e, c) => c.setState({ qty: Object.assign({}, c.state.qty, { [b.dataset.k]: Math.min(+b.dataset.max, (c.state.qty[b.dataset.k] || 1) + 1) }) }),
      stapleAdd: (b, e, c) => busy(b, () => addStaple(c, b.dataset.id, +(c.state.qty[b.dataset.id] || 1))),
      stapleSet: (b, e, c) => busy(b, () => addStaple(c, b.dataset.id, +b.dataset.n, b.dataset.playset)),
      kitAdd: (b, e, c) => addKitItem(b.dataset.v, b.dataset.t).then(() => c.setState({ inCart: Object.assign({}, c.state.inCart, { [b.dataset.v]: true }) })),
      retry: (b, e, c) => load(c),
    }, comboActions('hero', {
      onPick: (it) => openCard(it.card_id),
      onEnter: (q, c) => { if (!q.trim()) return; location.assign(c.state.heroOff ? route('shopifySearch', { q }) : route('cardSearch', { q: q.trim() })); },
    }), pasteActions({ onBuild: (text, parsed) => location.assign(builderUrlForText(text, parsed)) })),
  };
}

const SETS_KEY = 'mcc.sets.cache';
async function load(c) {
  c.setState({ loading: true });
  try { await cart.ready(); } catch (e) { /* basket optional */ }
  const [h, d, s, k, p] = await Promise.allSettled([api.health(), api.decks({ view: 'hub' }), api.sets(), api.kit({ all: '1' }), api.popular()]);
  const off = [h, d].every((x) => x.status === 'rejected' && x.reason && x.reason.offline);
  // sets stay visible when the engine is offline (Q14): last good /sets is kept on this device
  let sets = s.value || null;
  if (sets) { try { localStorage.setItem(SETS_KEY, JSON.stringify(sets)); } catch (e) { /* ignore */ } }
  else { try { sets = JSON.parse(localStorage.getItem(SETS_KEY) || 'null'); } catch (e) { sets = null; } }
  const decks = d.value || null;
  if (decks) normAll(decks.staples);
  c.setState({ loading: false, offline: off, health: h.value || null, decks, sets, kit: k.value || null, popular: popularOf(p.value, decks) });
  if (d.value && s.value) claim('hub');
  const first = shelfSets(sets)[0];
  if (first) loadFeat(c, first.code);
  if (new URLSearchParams(location.search).get('paste')) c.setState({ pText: '' }, () => { const t = c.root.querySelector('#mcc-hub-paste'); if (t) t.focus(); });
}

async function refresh(c) {
  const [d, p] = await Promise.allSettled([api.decks({ view: 'hub' }), api.popular()]);
  if (d.value) { normAll(d.value.staples); c.setState({ decks: d.value, popular: popularOf(p.value, d.value) }); }
  // shelf stock excludes the basket too: drop the per-set cache and reload the open tab
  c.setState({ feat: {} });
  if (c.state.featSet) loadFeat(c, c.state.featSet);
}

async function loadFeat(c, code) {
  c.setState({ featSet: code });
  if ((c.state.feat || {})[code]) return;
  try {
    const r = await api.search({ q: 'set:' + code, sort: 'value', per: 18 });
    c.setState({ feat: Object.assign({}, c.state.feat, { [code]: (r && r.results) || [] }) });
  } catch (e) { c.setState({ feat: Object.assign({}, c.state.feat, { [code]: [] }) }); }
}
// Popular chips (operator note #1, Q11): only Standard-legal cards with >= 1 copy available. /popular when the engine
// has it, else the in-stock staples (already legal + in stock), ranked by deck usage.
function popularOf(p, decks) {
  const items = p && Array.isArray(p.items) ? p.items : p && Array.isArray(p.cards) ? p.cards : null;
  if (items) return items.filter((x) => x.legal !== false && (x.copies_available == null || x.copies_available > 0)).slice(0, 6).map((x) => ({ q: x.q || x.name, chip: x.chip || x.name, id: x.card_id }));
  const st = (decks && decks.staples) || [];
  return st.filter((x) => x.legal !== false && x.copies_available > 0).sort((a, b) => ((b.used_in || {}).lists || 0) - ((a.used_in || {}).lists || 0)).slice(0, 6).map((x) => ({ q: x.name, id: x.card_id }));
}

// Page order (redesign 2026-10-18): one compact hero with two shopping paths, then cards anyone can buy now, then
// the competitive tools. Collectors no longer scroll past tournament decks to start shopping.
function view(s) {
  const w = s.w;
  const deckCols = w >= 1300 ? 6 : w >= 900 ? 3 : 2;
  const mobile = w < 750;
  return html`<div class="mcc-wrap">${crumbs([{ t: 'Home', href: '/' }, { t: 'Pokémon Singles' }])}</div>
  ${hero(s, mobile)}
  ${s.offline ? html`<div class="mcc-wrap" style="margin-bottom:16px">${offlineNotice(s.sets ? OFFLINE.banner : 'Card search and deck matching are offline. You can still use the shop’s normal search.')}</div>` : ''}
  ${shopSection(s, mobile)}
  ${archSection(s, deckCols, mobile)}
  ${staplesSection(s, mobile)}
  ${setsSection(s, w)}
  ${kitSection(s, w)}
  ${howSection()}`;
}

// free UK delivery threshold: the theme setting the cart drawer bar uses (singles-hub-config), so they never disagree
const freeOver = () => config().freeShippingThreshold || 130;
const inStockOf = (h) => (h ? h.store_in_stock_singles || h.in_stock_singles || 0 : 0);

function hero(s, mobile) {
  const trust = s.offline ? OFFLINE.status : `Dispatch within 2 working days · Free UK delivery over £${freeOver()}`;
  const n = inStockOf(s.health);
  const showPaste = !mobile || s.pShow || !!s.pText;
  return html`<section class="mcc-wrap mcc-hero" ${s.embedded ? html`aria-label="Search and deck builder"` : html`aria-labelledby="mcc-hub-h1"`}>
    <div class="mcc-hero__grid">
      <div class="mcc-hero__main">
        ${s.embedded ? html`<div class="mcc-hero__head" data-morph-skip data-mcc-hero-head></div>` : html`<p class="mcc-eyebrow">Pokémon singles${n ? ` · ${n.toLocaleString('en-GB')} in stock` : ''}</p>
        ${pageTitle(false, 'Find your next card.', { id: 'mcc-hub-h1' })}
        <p class="mcc-lede">${LEDE}</p>`}
        ${comboView(s, 'hero', { placeholder: 'Search cards, Pokémon, sets…', label: 'Search Pokémon singles' })}
        <div class="mcc-hero__ctas">
          <a class="mcc-btn mcc-btn--lg" href="#mcc-shop" data-click="heroCta" data-cta="browse">Browse singles →</a>
          <a class="mcc-btn mcc-btn--secondary mcc-btn--lg" href="#mcc-decks" data-click="heroCta" data-cta="build">Build a deck →</a>
        </div>
        <p class="mcc-hero__trust"><span class="mcc-dot" aria-hidden="true" style="${s.offline ? 'background:#A06207' : ''}"></span>${trust}</p>
      </div>
      <div class="mcc-panel mcc-pad mcc-import" id="mcc-import">
        <div class="mcc-import__head"><div><p class="mcc-eyebrow">Build your deck</p><h2 class="mcc-h3">Deck list importer</h2></div>${showPaste ? html`<button type="button" class="mcc-link mcc-small" data-click="pasteSample">Use the sample list</button>` : ''}</div>
        <p class="mcc-small mcc-muted mcc-import__lede">Paste a Pokémon TCG deck list to check availability and prices instantly.</p>
        ${showPaste ? pasteBox(s, { idPrefix: 'hub', cta: 'Check deck availability →', help: 'Works with Limitless (Copy to Clipboard), PTCGL (Deck → Export) and TCGplayer codes.' })
          : html`<button type="button" class="mcc-btn mcc-btn--secondary mcc-btn--block" data-click="pShow">Paste a deck list</button>`}
      </div>
    </div>
  </section>`;
}
export const LEDE = 'Search thousands of Pokémon singles, or build a competitive deck from cards we have in stock.';

// ---------------------------------------------------------------- 02 shop singles in stock
// The newest sets with real stock, most valuable card first (engine sort=value, within the set). One request per
// tab, kept per tab (no refetch when switching back); the basket change refresh clears it.
export function shelfSets(sets) {
  const all = ((sets && sets.series) || []).reduce((a, x) => a.concat(x.sets || []), []);
  return all.filter((t) => (t.in_stock || 0) >= 6).slice(0, 3);
}
const shortSet = (name) => String(name || '').replace(/^(ME|SV|SWSH|SM)[\d.]*:\s*/, '').replace(/^SM - /, '');
export function shelfPick(c, code) {
  const inSet = (p) => [p.set, p.set_code, p.set_upstream].some((x) => String(x || '').toUpperCase() === code);
  let best = null;
  (c.printings || []).filter(inSet).forEach((p) => (p.listings || []).forEach((l) => {
    if (l.buyable !== false && !l.is_playset && (l.copies_available || 0) > 0 && (!best || l.price > best.l.price)) best = { p, l };
  }));
  return best;
}
const shortStock = (n) => html`<span class="mcc-pill ${n >= 4 ? 'mcc-pill--ok' : 'mcc-pill--warn'}">${n === 1 ? 'Last one' : n >= 4 ? `${n} in stock` : `${n} left`}</span>`;

function shopSection(s, mobile) {
  const tabs = shelfSets(s.sets);
  if (!s.loading && !tabs.length) return '';
  const code = s.featSet || (tabs[0] && tabs[0].code);
  const t = tabs.find((x) => x.code === code) || tabs[0];
  const list = (s.feat || {})[code];
  const cols = s.w >= 1300 ? 6 : s.w >= 1000 ? 5 : s.w >= 750 ? 4 : 2;
  const picks = (list || []).map((c) => ({ c, b: shelfPick(c, code) })).filter((x) => x.b).slice(0, mobile ? 6 : cols);
  const pop = s.popular || [];
  return html`<section class="mcc-wrap mcc-sec" id="mcc-shop" aria-labelledby="mcc-shop-h">
    <div class="mcc-sec-head"><div><h2 class="mcc-h2" id="mcc-shop-h">Shop singles in stock</h2><p class="mcc-small mcc-muted">The best cards from our newest sets, ready to dispatch.</p></div>
      ${tabs.length > 1 ? html`<div class="mcc-seg" role="tablist" aria-label="Set">${tabs.map((x) => html`<button type="button" role="tab" aria-selected="${x.code === code ? 'true' : 'false'}" data-click="featTab" data-v="${x.code}">${shortSet(x.name)}</button>`)}</div>` : ''}</div>
    ${!list ? html`<div class="${mobile ? 'mcc-rail' : 'mcc-grid'}" style="--cols:${cols}" aria-hidden="true">${Array.from({ length: mobile ? 2 : cols }, () => html`<div class="mcc-skel mcc-shop-skel"></div>`)}</div>`
      : picks.length ? html`<div class="${mobile ? 'mcc-rail mcc-rail--shop' : 'mcc-grid'}" style="--cols:${cols}">${picks.map((x) => shelfTile(x.c, x.b))}</div>`
      : html`<p class="mcc-small mcc-muted">Nothing from this set is in stock right now.</p>`}
    <div class="mcc-shop__foot">
      ${pop.length ? html`<div class="mcc-row" data-mcc-popular><span class="mcc-small mcc-muted">Popular searches</span><div class="mcc-chips ${mobile ? 'mcc-chips--scroll' : ''}">${pop.map((x) => html`<button type="button" class="mcc-chip" data-click="popular" data-q="${x.q}">${pretty(x.chip || x.q)}</button>`)}</div></div>` : html`<span></span>`}
      ${t ? html`<a class="mcc-link mcc-small" href="${t.url || route('set', { handle: t.handle })}" data-click="featAll" data-v="${t.code}">See all ${(t.in_stock || 0).toLocaleString('en-GB')} in stock from ${shortSet(t.name)} →</a>` : ''}
    </div>
  </section>`;
}

function shelfTile(c, { p, l }) {
  const fin = /reverse/i.test(l.finish || '') ? ' · Reverse Holo' : '';
  return html`<article class="mcc-shop" data-key="sh-${l.variant_id}">
    <button type="button" class="mcc-shop__art" data-click="openCard" data-id="${c.card_id}" data-pid="${p.printing_id}" aria-label="Details for ${pretty(c.name)}">${cardArt(p.image_url, { name: c.name, code: p.label, w: 150 })}</button>
    <div class="mcc-shop__info">
      <h3 class="mcc-shop__name mcc-clip">${pretty(c.name)}</h3>
      <p class="mcc-xs mcc-muted mcc-clip">${p.label}${p.rarity ? ' · ' + p.rarity : ''}${fin}</p>
      <div class="mcc-shop__row"><span class="mcc-shop__price">${money(l.price)}</span>${shortStock(l.copies_available)}</div>
    </div>
    <button type="button" class="mcc-btn mcc-btn--block mcc-shop__add" data-click="shelfAdd" data-v="${l.variant_id}" data-n="${c.name}" data-price="${l.price}">Add to basket</button>
  </article>`;
}

// ---------------------------------------------------------------- 03 build a competitive deck
function archSection(s, cols, mobile) {
  if (s.loading) return html`<section class="mcc-wrap mcc-sec" id="mcc-decks"><div class="mcc-skel" style="height:24px;width:220px"></div><div class="mcc-grid" style="--cols:${cols};margin-top:16px">${[1, 2, 3, 4, 5, 6].slice(0, cols).map(() => html`<div class="mcc-skel" style="height:400px"></div>`)}</div></section>`;
  const d = s.decks;
  if (!d || !d.archetypes || !d.archetypes.length) return '';
  let arch = d.archetypes.slice();
  const filled = (a) => (a.has_list && a.buildability ? a.buildability.filled || 0 : -1);
  if (s.archSort === 'build') arch.sort((a, b) => filled(b) - filled(a) || (b.top8 || 0) - (a.top8 || 0));
  const c = mobile ? cols : fillGrid(arch.length, cols).cols; // no half-empty last row (operator note #2)
  return html`<section class="mcc-wrap mcc-sec" id="mcc-decks" aria-labelledby="mcc-arch-h">
    <div class="mcc-sec-head"><div><h2 class="mcc-h2" id="mcc-arch-h">Build a competitive deck</h2><p class="mcc-small mcc-muted">Tournament decks, checked live against our stock.</p></div>
      <div class="mcc-row"><div class="mcc-seg" role="tablist" aria-label="Sort decks">${[['build', 'Most buildable'], ['meta', 'Top-8 finishes']].map(([v, t]) => html`<button type="button" role="tab" aria-selected="${s.archSort === v ? 'true' : 'false'}" data-click="sortArch" data-v="${v}">${t}</button>`)}</div>
      <a class="mcc-link mcc-small" href="${route('competitive')}">See the full meta →</a></div></div>
    <div class="${mobile ? 'mcc-rail' : 'mcc-grid'}" style="--cols:${c};--art-h:${c >= 6 ? 190 : 230}px">${arch.map((a) => deckTile(a))}</div>
    <p class="mcc-src" style="margin-top:12px">${d.source.line}. Availability and prices live from our stock.</p>
  </section>`;
}

// Hub deck tile: answers three questions in order. Is it competitive? How much of it can I buy? What does that cost?
// One action: the deck view, where printings, swaps and "add everything available" live.
export function deckTile(a) {
  const b = a.buildability;
  const href = route('archetype', { slug: a.slug });
  const live = a.has_list && a.status !== 'retired';
  const go = live ? route('builderDeck', { id: a.lists[0] }) : href;
  const size = (b && b.deck_size) || 60;
  const got = b ? b.filled || 0 : 0;
  const pct = b && b.pct != null ? b.pct : Math.round((got / size) * 100);
  const missing = Math.max(0, size - got);
  return html`<article class="mcc-tile mcc-deck" style="--accent:${a.accent || '#D61463'}" data-key="${a.slug}">
    <a class="mcc-tile__art" href="${go}" tabindex="-1" aria-hidden="true" data-click="deckOpen" data-slug="${a.slug}">${cardArt(a.key_card_image, { name: a.name, code: a.key_card_label, w: 240 })}</a>
    <div class="mcc-tile__body">
      <h3 class="mcc-tile__name"><a href="${href}">${pretty(a.name)}</a>${tierChip(a.tier)}</h3>
      ${a.status === 'retired' ? html`<p class="mcc-tile__meta">${a.note || 'Retired deck'} · <span style="color:var(--mcc-bad,#B91C1C)">Not Standard legal</span></p>`
        : a.status === 'off_meta' ? html`<p class="mcc-tile__meta">${a.note || 'Outside the top decks'}</p>`
        : html`<p class="mcc-tile__meta">${a.share_text}</p>`}
      ${a.has_list && b ? html`<div class="mcc-deck__fill">
          <div class="mcc-deck__line"><span><b>${got} of ${size}</b> cards available</span><span class="mcc-deck__pct">${pct}%</span></div>
          ${bar([{ n: got, color: a.accent || '#D61463' }], size, { label: `${got} of ${size} cards available` })}
        </div>
        <div class="mcc-deck__cost"><div><span class="mcc-xs mcc-muted">Available cards total</span><b>${money(b.price)}</b></div>${missing ? html`<span class="mcc-pill mcc-pill--warn">${missing} missing</span>` : html`<span class="mcc-pill mcc-pill--ok">Whole deck in stock</span>`}</div>`
        : html`<div class="mcc-deck__fill"><span class="mcc-small mcc-muted">List coming soon</span></div>`}
      <a class="mcc-btn mcc-btn--block mcc-tile__btns" href="${go}" data-click="deckOpen" data-slug="${a.slug}">${live ? 'View deck & availability' : 'View deck'}</a>
    </div></article>`;
}

// The /pages/competitive tile (meta-first; guide + build buttons). The hub uses deckTile above.
// Deck tile: fixed-height info block, buttons pinned to the bottom (operator note #2). Same labels everywhere (Q26):
// "Read guide →" primary + "Build" secondary; "21% of top cuts"; buildability bar labelled and placed with its text (Q16).
export function archTile(a) {
  const b = a.buildability;
  const href = route('archetype', { slug: a.slug });
  const buildHref = a.has_list ? route('builderDeck', { id: a.lists[0] }) : null;
  return html`<article class="mcc-tile" style="--accent:${a.accent || '#D61463'}" data-key="${a.slug}">
    <a class="mcc-tile__art" href="${href}" tabindex="-1" aria-hidden="true">${cardArt(a.key_card_image, { name: a.name, code: a.key_card_label, w: 400 })}</a>
    <div class="mcc-tile__body">
      <div class="mcc-tile__info">
        <h3 class="mcc-tile__name">${tierChip(a.tier)}<a href="${href}">${pretty(a.name)}</a></h3>
        ${a.status === 'retired' ? html`<p class="mcc-tile__meta"><span>${a.note || 'Retired deck'}</span></p><p class="mcc-xs" style="color:var(--mcc-bad,#B91C1C)">Not Standard legal · casual / Expanded</p>`
          : a.status === 'off_meta' ? html`<p class="mcc-tile__meta"><span>${a.note || 'Outside the top decks'}</span></p><p class="mcc-xs mcc-muted">Standard legal</p>`
          : html`<p class="mcc-tile__meta"><span>${a.share_text}</span></p>`}
        ${a.has_list ? buildBar(b, a.accent) : html`<div class="mcc-build"><span class="mcc-build__t mcc-muted">List coming soon</span></div>`}
      </div>
      <div class="mcc-btns mcc-tile__btns">
        <a class="mcc-btn mcc-btn--sm" href="${href}" aria-label="Read the ${pretty(a.name)} guide">Read guide →</a>
        ${buildHref ? html`<a class="mcc-btn mcc-btn--secondary mcc-btn--sm" href="${buildHref}" aria-label="Build ${pretty(a.name)}">Build</a>` : html`<span class="mcc-btn mcc-btn--secondary mcc-btn--sm" aria-disabled="true" title="No list published yet">Build</span>`}
      </div>
    </div></article>`;
}

// ---------------------------------------------------------------- 04 competitive staples
function staplesSection(s, mobile) {
  const d = s.decks; if (!d || !d.staples) return '';
  const all = d.staples;
  if (all.length < 4) return ''; // never show a thin shelf
  const st = s.st4 ? all.filter((c) => fullSet(c) >= 4) : all;
  const cols = s.w >= 1500 ? 6 : s.w >= 1150 ? 5 : s.w >= 900 ? 4 : 2;
  const show = mobile || s.stAll ? st : st.slice(0, Math.max(cols, Math.floor(Math.min(st.length, cols * 2) / cols) * cols));
  return html`<section class="mcc-wrap mcc-sec" aria-labelledby="mcc-st-h">
    <div class="mcc-sec-head"><div><h2 class="mcc-h2" id="mcc-st-h">Competitive staples in stock</h2><p class="mcc-small mcc-muted">The cards most tournament decks play. Add a playset in one tap.</p></div>
      <div class="mcc-row"><button type="button" class="mcc-chip" aria-pressed="${s.st4 ? 'true' : 'false'}" data-click="st4">${s.st4 ? '✓ ' : ''}Only 4+ available</button>
      ${!mobile && st.length > show.length ? html`<button type="button" class="mcc-link mcc-small" data-click="stAll">See all ${st.length} →</button>` : !mobile && s.stAll && st.length > cols ? html`<button type="button" class="mcc-link mcc-small" data-click="stAll">Show fewer</button>` : ''}</div></div>
    ${st.length ? html`<div class="${mobile ? 'mcc-rail' : 'mcc-grid'}" style="--cols:${cols}">${show.map((c) => stapleTile(c, s))}</div>` : html`<p class="mcc-small mcc-muted">No staples have 4 or more copies in stock right now.</p>`}
  </section>`;
}
// copies a playset can be made of right now (one product or mixed singles), basket excluded
function fullSet(c) { normCard(c); return c.playset ? c.playset.fulfillable_qty : Math.min(4, c.copies_available); }
// "Played in 15/17 tournament lists" (the engine's "In 15 of 17 real lists · 9 of 10 top d…" was clipped on tiles)
export function usageLine(c) {
  const u = c.used_in;
  return u && u.of_lists ? `Played in ${u.lists}/${u.of_lists} tournament lists` : c.usage_text;
}

// Staple tile: one fixed info block and a bottom-pinned button group. When a full playset is available the playset
// is THE action; otherwise "Add N" is. One stock figure (copies across every printing), and the printing line says
// whether other interchangeable printings exist.
export function stapleTile(c, s) {
  normCard(c);
  const ch = c.cheapest;
  const all = c.copies_available;               // across every printing, basket excluded
  const qty = Math.max(1, Math.min((s.qty || {})[c.card_id] || 1, Math.max(1, all)));
  const p = c.printings.find((x) => x.printing_id === (ch && ch.printing_id)) || c.printings[0];
  const ful = fullSet(c);
  const avl = availableListings(c);
  const setN = Math.min(4, ful);
  const mixed = new Set(picksFor(avl, setN).map((x) => (avl.find((l) => l.variant_id === x.variant_id) || {}).printing_id)).size > 1;
  const others = c.printings.filter((x) => x.copies_available > 0 && x !== p).length;
  const playFirst = ful >= 4;
  // short label (the tile's printing line already says when other printings exist): "Add playset (4) · £5.16" when one
  // printing fills it, "Add 4 · £3.66" when it mixes printings, "Add all 3 · £2.97" when fewer than 4 are left
  const setText = playsetLabel(setN, avl, false).replace(/^Add playset \(4\)/, mixed ? 'Add 4' : 'Add playset (4)');
  const setBtn = html`<button type="button" class="mcc-btn ${playFirst ? '' : 'mcc-btn--secondary'}" data-click="stapleSet" data-id="${c.card_id}" data-n="${setN}" ${attr('data-playset', ful >= 4 && c.playset && c.playset.kind === 'playset_product', '1')}${attr('title', mixed, 'Mixed printings of the same card, all tournament legal')}>${setText}</button>`;
  const addRow = html`<div class="mcc-btnrow">${stepper({ value: qty, min: 1, max: all, minus: 'qMinus', plus: 'qPlus', label: 'Quantity of ' + c.name, data: { k: c.card_id, max: all } })}<button type="button" class="mcc-btn ${playFirst ? 'mcc-btn--secondary' : ''}" data-click="stapleAdd" data-id="${c.card_id}">Add ${qty}</button></div>`;
  return html`<article class="mcc-staple" data-key="st-${c.card_id}">
    <button type="button" class="mcc-staple__art" data-click="openCard" data-id="${c.card_id}" data-pid="${p && p.printing_id}" aria-label="Details for ${pretty(c.name)}">${cardArt(p && p.image_url, { name: c.name, code: p && p.label, w: 140 })}</button>
    <div class="mcc-staple__info">
      <p class="mcc-xs mcc-muted mcc-staple__use">${usageLine(c)}</p>
      <h3 class="mcc-staple__name mcc-clip">${pretty(c.name)}</h3>
      <p class="mcc-xs mcc-muted mcc-clip">${p ? p.label + ' · ' + p.rarity : ''}${others ? html` · <span title="Same card, same game text: any printing is tournament legal">+${others} other printing${others === 1 ? '' : 's'}</span>` : ''}</p>
      <div class="mcc-staple__row"><span class="mcc-staple__price">${ch ? money(ch.price) : '—'}</span>${all > 0 ? shortStock(all) : stockPill(0, c.in_basket)}</div>
    </div>
    <div class="mcc-btngroup mcc-staple__btns">
      ${all > 0 ? (playFirst ? html`${setBtn}${addRow}` : all > 1 ? html`${addRow}${setBtn}` : addRow)
      : html`<div class="mcc-btnrow"><button type="button" class="mcc-btn mcc-btn--ok" disabled aria-disabled="true">${c.in_basket ? `${c.in_basket} already in your basket` : 'Sold out'}</button></div><button type="button" class="mcc-btn mcc-btn--secondary" disabled aria-disabled="true">Nothing more to add</button>`}
    </div>
  </article>`;
}

async function addStaple(c, cardId, n, playset) {
  const st = (c.state.decks && c.state.decks.staples || []).concat(c.state.results || []).find((x) => x.card_id === cardId);
  if (!st) return;
  const items = [];
  normCard(st);
  if (playset && st.playset && st.playset.kind === 'playset_product' && st.playset.variant_id) items.push({ variant_id: st.playset.variant_id, qty: 1 });
  else items.push(...picksFor(availableListings(st), n));
  try {
    const r = await cart.addItems(items);
    const got = r.added.reduce((a, x) => a + x.qty, 0);
    if (!got) toast('You already have all we stock in your basket.', 'stock');
    else toast(`Added ${got}× ${pretty(st.name)}${got < n && !playset ? ' (all we have)' : ''} to your basket.`, 'ok');
  } catch (e) { toast('We couldn’t add that to your basket. Please try again.', 'error'); }
}
export { addStaple };

async function addShelf(vid, name) {
  try {
    const r = await cart.addItems([{ variant_id: vid, qty: 1 }]);
    if (!r.added.length) toast('You already have all we stock in your basket.', 'stock');
    else toast(`Added ${pretty(name)} to your basket.`, 'ok');
  } catch (e) { toast('We couldn’t add that to your basket. Please try again.', 'error'); }
}

// Grid fill (operator note #3): pick a column count that leaves no half-empty last row, else end on an "All sets" tile.
export function fillGrid(n, max, min = 2) {
  for (let c = max; c >= Math.max(min, Math.ceil(max / 2)); c--) {
    if (n % c === 0) return { cols: c, extra: false };
    if ((n + 1) % c === 0) return { cols: c, extra: true };
  }
  return { cols: max, extra: n % max !== 0 };
}

// ---------------------------------------------------------------- 05 browse by set
// Set tiles show the set's own logo (its Shopify collection image, already on our CDN) and live stock per set.
// Sets without an image fall back to the set code. Logos are lazy, sized and reserve their box (no layout shift).
function setsSection(s, w) {
  const d = s.sets; if (!d || !d.series || !d.series.length) return '';
  const ser = d.series.find((x) => x.key === s.series) || d.series[0];
  const max = w >= 1200 ? 6 : w >= 750 ? 4 : 2;
  const sets = s.setsAll ? ser.sets : ser.sets.slice(0, max * 2);
  const g = fillGrid(sets.length, max);
  const shown = g.extra && !s.setsAll && sets.length >= g.cols * 2 ? sets.slice(0, g.cols * 2 - 1) : sets;
  const more = !s.setsAll && (g.extra || ser.sets.length > shown.length);
  return html`<section class="mcc-wrap mcc-sec" aria-labelledby="mcc-sets-h">
    <div class="mcc-sec-head"><h2 class="mcc-h2" id="mcc-sets-h">Browse by set</h2>
      <div class="mcc-seg" role="tablist" aria-label="Series">${d.series.map((x) => html`<button type="button" role="tab" aria-selected="${x.key === ser.key ? 'true' : 'false'}" data-click="series" data-v="${x.key}">${x.name}</button>`)}</div></div>
    <div class="mcc-grid mcc-sets" style="--cols:${g.cols}">${shown.map((t) => setTile(t))}
      ${more ? html`<button type="button" class="mcc-set2 mcc-set2--all" data-click="setsAll" data-key="all-sets"><span class="mcc-set2__logo"><span class="mcc-set2__code">All sets</span></span><span class="mcc-set2__name">${ser.name}</span><span class="mcc-set2__meta">Show all ${ser.sets.length} sets →</span></button>` : ''}</div>
  </section>`;
}
function setTile(t) {
  const img = ((window.MCC_CONFIG || {}).setLogos || {})[t.code] || t.collection_image_url || t.logo_url;
  const n = t.in_stock || 0;
  return html`<a class="mcc-set2${n ? '' : ' is-empty'}" href="${t.url || route('set', { handle: t.handle })}" data-key="${t.code}" data-click="setOpen" data-v="${t.code}">
    <span class="mcc-set2__logo${img ? '' : ' mcc-set2__logo--none'}">${img ? html`<img src="${sized(img, 220)}" srcset="${sized(img, 220)} 1x, ${sized(img, 400)} 2x" alt="" width="220" height="90" loading="lazy" decoding="async">` : html`<span class="mcc-set2__code">${t.code}</span>`}</span>
    <span class="mcc-set2__name">${shortSet(t.name)}</span>
    <span class="mcc-set2__meta">${t.code} · ${n ? html`<b>${n.toLocaleString('en-GB')} in stock</b>` : 'none in stock'} →</span></a>`;
}

// ---------------------------------------------------------------- 06 accessories (compact: one row, rest on request)
function kitSection(s, w) {
  if (!s.kit || !s.kit.items.length) return '';
  const items = s.kit.items;
  const lim = w >= 990 ? 6 : 4;
  const show = s.kitAll ? items : items.slice(0, lim);
  return html`<section class="mcc-wrap mcc-sec" aria-labelledby="mcc-kit-h"><div class="mcc-sec-head"><div><h2 class="mcc-h2" id="mcc-kit-h">Accessories in stock</h2><p class="mcc-small mcc-muted">Sleeves · deck boxes · playmats · card protection</p></div>
    ${items.length > lim ? html`<button type="button" class="mcc-link mcc-small" data-click="kitAll">${s.kitAll ? 'Show fewer' : `Show all ${items.length} →`}</button>` : ''}</div>
    ${kitView(show, { inCart: s.inCart, w, showTheme: true })}
    ${kitNote(s.kit) ? html`<p class="mcc-src" style="margin-top:10px">${kitNote(s.kit)}</p>` : ''}</section>`;
}

function howSection() {
  // the one "How it works" on the hub (Q32)
  const faq = [
    ['Which printing will I get?', 'Any printing with the same name and game text is tournament legal, so in Budget mode we pick the cheapest legal printing we have. Choose As listed for the exact set and number, or Premium for full arts and holos. You can change any card before you add it.'],
    ['What condition are the cards?', 'Singles are Near Mint unless the listing says otherwise, and every card ships sleeved and protected.'],
    ['How much is postage?', `Free UK delivery on orders over £${freeOver()}. In-stock singles dispatch within 2 working days.`],
    ['What happens when I request a card?', 'It goes on your wanted list and our buying list, so we know which cards to restock first. Requests from a deck link back to that deck. Requests last 90 days.'],
  ];
  return html`<section class="mcc-sec mcc-sec--alt"><div class="mcc-wrap mcc-how">
    <div><h2 class="mcc-h2" style="margin-bottom:16px">How it works</h2><ol>
      <li><span>1</span><div><b>Paste your list</b><p class="mcc-small mcc-muted">Copy it from Limitless, PTCGL or a friend. We read set codes, numbers, plain names and TCGplayer codes.</p></div></li>
      <li><span>2</span><div><b>We match every card</b><p class="mcc-small mcc-muted">Budget, as listed, or premium printings. Tick off the cards you already own.</p></div></li>
      <li><span>3</span><div><b>Add what we have, request the rest</b><p class="mcc-small mcc-muted">Everything in stock goes in your basket in one tap. Missing cards go on your wanted list.</p></div></li></ol></div>
    <div class="mcc-faq"><h2 class="mcc-h2" style="margin-bottom:16px">Questions</h2>${faq.map(([q, a]) => html`<details><summary>${q}</summary><div>${a}</div></details>`)}</div>
  </div></section>`;
}
